import { createFileRoute } from '@tanstack/react-router';
import { formStepsSearchSchema } from '@/components/form/FormStepsPage';
import { AddImmobilisationPage } from '@/features/immobilisations/components/AddImmobilisationPage';

export const Route = createFileRoute('/$commiteeSlug/immobilisations/create')({
  component: AddImmobilisationPage,
  validateSearch: formStepsSearchSchema,
});
